export default __webpack_public_path__ + "static/media/brakekit-small-yellow.97101b7d.webp";